import { type FC } from 'react';
import { Form } from 'react-bootstrap';
import cx from 'clsx';

import Metadata from '@editor2/components/Metadata';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';
import { updateElement } from '@editor2/reducers/editor/editorSlice';
import { type ResponseBoard } from '@editor2/types/pageElements';
import { responseBoardElement } from './styles';
import QuestionConfig from '../Question/QuestionConfig';
import ValidationsBlock from '../Question/ValidationsBlock';
import ResponseBoardQuestion from './Question';
import { elementCommonStyles } from '@editor2/styles/element';

interface Props {
	element: ResponseBoard;
	courseId: number;
	pageType: string;
}

const ResponseBoardElement: FC<Props> = (props) => {
	const { element, courseId, pageType } = props;

	const commonPayload = { elementId: element.family_id, courseId };
	const debouncedDispatch = useDebouncedDispatch();

	const onDebouncedChange = (value) => {
		debouncedDispatch(updateElement({ ...commonPayload, ...value }));
	};

	return (
		<Form className={cx(responseBoardElement, elementCommonStyles)}>
			<Metadata
				courseId={courseId}
				metadata={element.metadata}
				onDebouncedChange={onDebouncedChange}
			/>

			<Form.Group>
				{element.questions.map((question, index) => (
					<ResponseBoardQuestion
						key={index}
						element={element}
						courseId={courseId}
						question={question}
						index={index}
					/>
				))}
			</Form.Group>

			<QuestionConfig element={element} courseId={courseId} pageType={pageType} />

			<ValidationsBlock element={element} courseId={courseId} />
		</Form>
	);
};

export default ResponseBoardElement;
